<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1BGMd82/images/9781626560758.jpg?1736602766558" alt="This image is the cover for the book Social Labs Revolution"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Social Labs Revolution
      </h1>
      <p class="bookDescription body article font2">
        <p>Current responses to our most pressing societal challenges‚Äîfrom poverty to ethnic conflict to climate change‚Äîare not working. These problems are incredibly dynamic and complex, involving an ever-shifting array of factors, actors, and circumstances. They demand a highly fluid and adaptive approach, yet we address them by devising fixed, long-term plans. Social labs, says Zaid Hassan, are a dramatically more effective response. <br/><br/>Social labs bring together a diverse a group of stakeholders‚Äînot to create yet another five-year plan but to develop a portfolio of prototype solutions, test those solutions in the real world, use the data to further refine them, and test them again. Hassan builds on a decade of experience‚Äîas well as drawing from cutting-edge research in complexity science, networking theory, and sociology‚Äîto explain the core principles and daily functioning of social labs, using examples of pioneering labs from around the world. He offers a new generation of problem solvers an effective, practical, and exciting new vision and guide.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Zaid Hassan, Joi Ito
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Berrett–Koehler
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?584335fb